module.exports = "/images/veil-8.jpg";